import "./infopanel.css";
import "@esri/calcite-components/components/calcite-fab";
import "@esri/calcite-components/components/calcite-chip";
import "@esri/calcite-components/components/calcite-notice";
import "@esri/calcite-components/components/calcite-link";
import "@esri/calcite-components/components/calcite-card";
import "@esri/calcite-components/components/calcite-tooltip";

import texts from "../../assets/texts/texts";
import { useEffect, useRef } from "react";


const navigation = [
  { icon: "W", description: texts.infopanel.alternativcontrol.w },
  { icon: "S", description: texts.infopanel.alternativcontrol.s },
  { icon: "D", description: texts.infopanel.alternativcontrol.d },
  { icon: "A", description: texts.infopanel.alternativcontrol.a },
  { icon: "←", description: texts.infopanel.alternativcontrol.left },
  { icon: "↑", description: texts.infopanel.alternativcontrol.up },
  { icon: "↓", description: texts.infopanel.alternativcontrol.down },
  { icon: "→", description: texts.infopanel.alternativcontrol.right },
  { icon: "ESC", description: texts.infopanel.alternativcontrol.esc },
];

const tools = [
  { icon: "information-letter", description: texts.infopanel.tools.info },
  { icon: "search", description: texts.infopanel.tools.search },
  { icon: "home", description: texts.infopanel.tools.home },
  { icon: "minus", description: texts.infopanel.tools.minus },
  { icon: "plus", description: texts.infopanel.tools.plus },
  { icon: "basemap", description: texts.infopanel.tools.basemaps },
  { icon: "layers", description: texts.infopanel.tools.layers },
  {
    icon: "organization",
    description: texts.widgets.uploadmodel.projekts.title,
  },
  { icon: "upload", description: texts.infopanel.tools.upload },
  { icon: "line-of-sight", description: texts.infopanel.tools.viewanalyse },
  { icon: "view-visible", description: texts.infopanel.tools.viewpoints },
  { icon: "date-time", description: texts.infopanel.tools.daytime },
  { icon: "partly-cloudy", description: texts.infopanel.tools.weather },
  { icon: "measure-line", description: texts.infopanel.tools.measure },
  { icon: "compass-needle", description: texts.infopanel.tools.compas },
];
function Infopanel({ onChange }) {
  const visibleHandler = () => {
    onChange(false);
  };

  const infoTools = (type, icon, description, index) => {
    if (type === "icon") {
      return (
        <li className="infoTools" key={index}>
          <calcite-chip
            icon={icon}
            value={icon}
            label={icon}
            scale="s"
          ></calcite-chip>
          <p>{description}</p>
        </li>
      );
    } else if (type === "html") {
      return (
        <li className="infoTools" key={index}>
          <calcite-chip value={icon} label={icon} scale="s">
            {icon}
          </calcite-chip>
          <p>{description}</p>
        </li>
      );
    }
  };

    const buttonRef = useRef(null);
    const tooltipRef = useRef(null);
  
    useEffect(() => {
      if (buttonRef.current && tooltipRef.current) {
        tooltipRef.current.referenceElement = buttonRef.current;
      }
    }, []);

  return (
    <>
      <div className="infoPanel">
        <div className="infoHeader">
          {" "}
          <h1>{texts.title}</h1>
          <calcite-fab
            className="infoHeader__buton"
            appearance="outline-fill"
            icon="x"
            label="Zavřít panel"
            onClick={() => {
              visibleHandler();
            }}
          ></calcite-fab>
        </div>
        <div className="infoContent">
          <h3>{texts.infopanel.infoSection.title}</h3>

          <calcite-notice open icon="file-text" kind="info">
            <div slot="title">
              {/* {texts.infopanel.infoSection.manual}{" "} */}
              <calcite-link
                href={texts.infopanel.infoSection.manualURL}
                target="_blank"
              >
                {texts.infopanel.infoSection.manual}
                {/* {texts.hyperlink} */}
              </calcite-link>
            </div>
          </calcite-notice>

          <calcite-notice open icon="popup" kind="info">
            <div slot="title">
              {/* {texts.infopanel.infoSection.metadata}{" "} */}
              <calcite-link
                href={texts.infopanel.infoSection.metaDataUrl}
                target="_blank"
              >
                {texts.infopanel.infoSection.metadata}
                {/* {texts.hyperlink} */}
              </calcite-link>
            </div>
          </calcite-notice>
          <h3>{texts.infopanel.inAplication.title}</h3>

          <calcite-notice open icon="3d-building" kind="neutral">
            <div slot="title">{texts.infopanel.inAplication.buildings}</div>
          </calcite-notice>
          <calcite-notice open icon="tree" kind="success">
            <div slot="title">
              <span>{texts.infopanel.inAplication.trees}</span>{" "}
              <calcite-link
                href={texts.infopanel.inAplication.treesHyperlink}
                target="_blank"
              >
                {texts.infopanel.inAplication.treesHyperlinkText}
              </calcite-link>{" "}
              <span>{texts.infopanel.inAplication.trees_2}</span>{" "}
              <span id="treesSpecies" ref={buttonRef}>
                {" "}
                {texts.infopanel.inAplication.treesSpecies.button}
              </span>
              <span> {texts.infopanel.inAplication.and} </span>
              <span id="treesHight">
                {texts.infopanel.inAplication.treesHight.button}
              </span>
            </div>
          </calcite-notice>

          <calcite-tooltip ref={tooltipRef}>
            <span className="my-tooltip-text tooltip-term " >
              {texts.infopanel.inAplication.treesSpecies.title}
            </span>
          </calcite-tooltip>
          <calcite-tooltip reference-element="treesHight">
            <span className="my-tooltip-text tooltip-term" >
              {texts.infopanel.inAplication.treesHight.title}
            </span>
          </calcite-tooltip>
          <calcite-notice open icon="upload" kind="danger">
            <div slot="title">
              {texts.infopanel.inAplication.insertbuilding}
            </div>
          </calcite-notice>
          <calcite-notice open icon="organization" kind="warning">
            <div slot="title">{texts.infopanel.inAplication.projects}</div>
  {/*           <div slot="message">
              {texts.infopanel.inAplication.projectsInfo}
            </div> */}
          </calcite-notice>
          <h3>{texts.infopanel.technicSection.title}</h3>
          <calcite-notice open icon="gear" kind="info">
            <div slot="title">
              {texts.infopanel.technicSection.text_1}
              <calcite-link href="https://get.webgl.org/" target="_blank">
                {texts.infopanel.technicSection.hyperlink}
              </calcite-link>
              {texts.infopanel.technicSection.text_2}
            </div>
          </calcite-notice>

          <h3>{texts.infopanel.downloads.title}</h3>
          <calcite-notice open icon="download" kind="info">
            <div slot="title">
              {texts.infopanel.downloads.paragraph_1.text_1}{" "}
              <calcite-link
                href="https://data.brno.cz/maps/dc95041d63e44e129ba0d9258a1dddb4/about"
                target="_blank"
              >
                {texts.infopanel.downloads.paragraph_1.hyperlink_1}
              </calcite-link>
               {". "}
              {texts.infopanel.downloads.paragraph_1.text_2}
              {" "}
              <calcite-link
                href="https://webmaps.kambrno.cz/Teren_A_Budovy_Ke_Stazeni/"
                target="_blank"
              >
                {texts.infopanel.downloads.paragraph_1.hyperlink_2}
              </calcite-link>
              {"."}
            </div>

            <div className="downloads_points" slot="title">
              <b>{texts.infopanel.downloads.paragraph_2.title}</b>{" "}
              {texts.infopanel.downloads.paragraph_2.text_1}{" "}
              <calcite-link
                href="https://webmaps.kambrno.cz/3d-model/APP/asset/DATA/Mista_Pohledu_Na_Vedutu_Mesta_SHP.zip"
                target="_blank"
              >
                {".shp"}
              </calcite-link>{" "}
              {texts.infopanel.downloads.paragraph_2.text_2}{" "}
              <calcite-link
                href="https://webmaps.kambrno.cz/3d-model/APP/asset/DATA/Mista_Pohledu_Na_Vedutu_Mesta_DWG.zip"
                target="_blank"
              >
                  {".dwg"}
              </calcite-link>
              {"."}
              {texts.infopanel.downloads.paragraph_2.text_3}
            </div>
          </calcite-notice>
          <div className="navigationDescription">
            <h3>{texts.infopanel.controls.title}</h3>
            <calcite-card>
              <p>{texts.infopanel.controls.paragraph_1}</p>
              <p>{texts.infopanel.controls.paragraph_2}</p>
            </calcite-card>
            <h3>{texts.infopanel.alternativcontrol.title}</h3>
            <calcite-card>
              <ul slot="title">
                {navigation.map((value, index) =>
                  infoTools("html", value.icon, value.description, index),
                )}
              </ul>
            </calcite-card>
            <h3>{texts.infopanel.tools.title}</h3>
            <calcite-card>
              <ul>
                {tools.map((value, index) =>
                  infoTools("icon", value.icon, value.description, index),
                )}
              </ul>
            </calcite-card>
          </div>
        </div>
      </div>
    </>
  );
}

export default Infopanel;
